<fin-booking-widget-selector
  class="flex flex-1 grow"
  [label]="'passengersAndClass.label' | finLocalization"
  [disabled]="disabled"
  (click)="openModal()"
  data-test-pax-amount-travel-class-selector
>
  <div class="flex flex--middle">
    <fcom-icon [name]="(totalPax$ | async) > 1 ? 'multi-pax' : 'single-pax'" class="icon-small"> </fcom-icon>
    <span data-test-pax-amount-travel-class-text>
      {{ totalPax$ | async }},
      {{
        'travelClass.' +
          ((travelClass$ | async) === GlobalBookingTravelClass.MIXED
            ? 'mixedCombined'
            : (travelClass$ | async | lowercase)) | finLocalization
      }}
    </span>
  </div>
</fin-booking-widget-selector>

<fcom-modal
  [(open)]="modalOpen"
  [title]="'passengersAndClass.label' | finLocalization"
  [fitToContent]="true"
  data-test-pax-amount-travel-class-modal
>
  <div>
    <ul id="pax-details" class="flex flex--column pr-large-x" tabindex="-1">
      <li
        *ngFor="let paxItem of paxAmount$ | async | keyvalue"
        class="flex flex--space-between flex--center fill ps-xsmall-y"
        [attr.data-test-pax-amount]="paxItem.key"
      >
        <div>
          <div class="font-body-1 capitalize">
            {{
              'bookingWidget.passenger.' + paxItem.key + (paxItem.value <= 1 ? '.singular' : '.plural')
                | finLocalization
            }}
            {{ 'bookingWidget.passenger.' + paxItem.key + '.ageDefinition' | finLocalization }}
          </div>
          <div class="font-body-2 nordic-blue-900-text">
            {{ 'bookingWidget.passenger.' + paxItem.key + '.ageRuleDefinition' | finLocalization }}
          </div>
        </div>
        <fin-plus-minus-selector
          *ngIf="paxAmountConfig$ | async as paxAmountConfig"
          class="fill nordic-blue-900-text"
          [min]="paxAmountConfig[paxItem.key].min"
          [max]="paxAmountConfig[paxItem.key].max"
          [model]="paxItem.value"
          [decreaseLabel]="'passengerLabels.removeAdult' | finLocalization"
          [increaseLabel]="'passengerLabels.addAdult' | finLocalization"
          [title]="paxItem.value.toString()"
          [iconSize]="'icon-large'"
          [textSize]="'font-heading-3'"
          [buttonPadding]="false"
          [controls]="paxItem.key + '-total-' + paxItem.value"
          (increment)="onPaxDetailsUpdate($event, paxItem.key, AmountUpdateType.INCREMENT)"
          (decrement)="onPaxDetailsUpdate($event, paxItem.key, AmountUpdateType.DECREMENT)"
        >
        </fin-plus-minus-selector>
      </li>
    </ul>

    <ul id="to-travel-class" role="radiogroup" class="flex flex--column ps-xsmall-y">
      <li
        *ngFor="let tClass of availableTravelClasses$ | async; let first = first; let last = last"
        [attr.id]="'to-travel-class-' + tClass"
        class="flex flex--middle flex--space-between focus-inset link-hover pr-large-x"
        [class.border-top]="first"
        [class.border-bottom]="!last"
        (click)="onTravelClassSelect(tClass)"
      >
        <input
          type="radio"
          class="is-vishidden"
          name="travelClass"
          [id]="'travelClass-' + tClass"
          [value]="tClass"
          [checked]="(travelClass$ | async) === tClass"
          [tabindex]="(travelClass$ | async) === tClass ? 0 : -1"
        />
        <label
          [for]="'travelClass-' + tClass"
          class="fill font-body-1 ps-medium-y focus-inset link-hover nordic-blue-900-text"
        >
          {{
            'travelClass.' + (tClass === GlobalBookingTravelClass.MIXED ? 'mixedCombined' : (tClass | lowercase))
              | finLocalization
          }}
        </label>

        <fcom-icon
          *ngIf="(travelClass$ | async) === tClass"
          name="checkmark"
          class="icon-medium nordic-blue-900-text"
        ></fcom-icon>
      </li>
    </ul>
  </div>
</fcom-modal>
